export const MEMBERSHIP_FETCH_FAIL = 'MEMBERSHIP_FETCH_FAIL';
export const MEMBERSHIP_FETCH_START = 'MEMBERSHIP_FETCH_START';
export const MEMBERSHIP_FETCH_SUCCESS = 'MEMBERSHIP_FETCH_SUCCESS';

export const MEMBERSHIP_SET_PRODUCT_FAIL = 'MEMBERSHIP_SET_PRODUCT_FAIL';
export const MEMBERSHIP_SET_PRODUCT_START = 'MEMBERSHIP_SET_PRODUCT_START';
export const MEMBERSHIP_SET_PRODUCT_SUCCESS = 'MEMBERSHIP_SET_PRODUCT_SUCCESS';
